<template>
  <div class="editor scroll-vertical">
    <detail-item
      name="Path"
      imgName="circle">
      {{ binary.path }}
    </detail-item>
    <alert-log-signing-info
      :signingInfo="binary.signingInfo"
      :related="related">
    </alert-log-signing-info>
    <detail-item
      v-if="binary.xattrs && binary.xattrs.length > 0"
      name="XAttrs"
      imgName="circle">
      <div class="vertical">
        <div v-for="attr in binary.xattrs" :key="attr" class="attr">{{ attr }}</div>
      </div>
    </detail-item>
    <detail-item
      name="Hash"
      imgName="circle">
      sha1: {{ binary.sha1hex }}<br>
      sha256: {{ binary.sha256hex }}
    </detail-item>
    <detail-item
      name="Modified"
      imgName="circle">
      {{ binary.modified | formatEpochDate(gmt) }}
    </detail-item>
    <detail-item
      name="Changed"
      imgName="circle">
      {{ binary.changed | formatEpochDate(gmt) }}
    </detail-item>
    <detail-item
      name="Created"
      imgName="circle">
      {{ binary.created | formatEpochDate(gmt) }}
    </detail-item>
    <detail-item
      name="Accessed"
      imgName="circle">
      {{ binary.accessed | formatEpochDate(gmt) }}
    </detail-item>
  </div>
</template>

<script>
import alertlog from '@/mixins/alertlog';
import gmt from '@/mixins/gmt';
import DetailItem from '@/components/DetailItem.vue';
import AlertLogSigningInfo from '@/components/alertlogs/AlertLogSigningInfo.vue';

export default {
  name: 'AlertLogBinary',
  mixins: [alertlog, gmt],
  components: {
    DetailItem,
    AlertLogSigningInfo,
  },
  props: {
    binary: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.vertical {
  display: flex;
  flex-direction: column;
}

.attr {
  width: 100%;
}
</style>
